import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconNames } from '../../common/constants/icon-names';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { ForeignTradePendingDocument } from '../../store/models/foreign-trade.model';

@Component({
  selector: 'ui-document-pending',
  templateUrl: './document-pending.component.html',
  styleUrls: ['./document-pending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPendingComponent {
  @Input() documents: ForeignTradePendingDocument[];
  notAvailable = NOT_AVAILABLE;
  iconNameList = IconNames;

  columns: string[] = [
    'arrivalDate',
    'clearanceDate',
    'deviationDescription',
    'beginDate',
    'endDate',
    'observation',
    'justification',
    'aimedBy',
    'concludedBy',
    'conclusionEntity',
    'invoice',
    'materialDeviation',
    'deviationOrderItem',
  ];
}
